import SearchService from "../core/services/searchapi.service";

export default {

  setAvailability(availability) {
    return SearchService.post(`Availability`, availability)
  },
}
